module.exports = __webpack_public_path__ + "img/m-hetongyuebaobiao.06584477.svg";